// extracted by mini-css-extract-plugin
module.exports = {"loader":"LayoutWrapperTopbar_loader__1XKgE","root":"LayoutWrapperTopbar_root__3khlh"};